import { CatSkeleton } from '@blocks-react/components/Skeleton';
import { useBreakpoint } from '../../../hooks';
import { PAGE_BREAKPOINTS } from '../../../constants/commonConstants';
import { v4 as uuid } from 'uuid';

export const DealerLocatorTermsLoader = () => {
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  return (
    <div className="cat-u-margin-top-lg">
      <CatSkeleton
        width={isMD ? '40%' : '80%'}
        size="sm"
        className={`cat-u-display-block cat-u-margin-bottom-${
          isMD ? 'xl' : 'md'
        }`}
      />
      <div
        className={`cat-u-padding-right-${
          isMD ? 'lg' : 'none'
        } cat-u-padding-left-${isMD ? 'lg' : 'none'}`}
      >
        {Array(isMD ? 16 : 21)
          .fill(true)
          .map((_skeletonCard) => {
            return (
              <CatSkeleton
                className="cat-u-display-block cat-u-margin-bottom-md"
                data-testid="skeleton-loader"
                key={`skeletonCard-${uuid()}`}
                size="sm"
              />
            );
          })}
      </div>
    </div>
  );
};
